import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import './styles.css';

const MarkdownDisplay = ({ content, className = '' }) => {
	if (!content) {
		return null;
	}

	return (
		<div className={`markdown-display prose prose-sm max-w-none ${className}`}>
			<Markdown
				remarkPlugins={[remarkGfm]}
				components={{
					// Custom image component with styling
					img: ({ node, ...props }) => (
						<img
							{...props}
							className="max-w-full h-auto rounded-md my-2"
							loading="lazy"
						/>
					),
					// Ensure links open in new tab
					a: ({ node, ...props }) => (
						<a
							{...props}
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-600 hover:text-blue-800 underline"
						/>
					),
				}}
			>
				{content}
			</Markdown>
		</div>
	);
};

export default MarkdownDisplay;
